module.exports = __webpack_public_path__ + "img/icon-dangerous-goods-woodpacking-text-en.3bfffc35.svg";